import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Layout } from "./components";
import { MainPage } from "./pages/MainPage";
import { WalletPage } from "./pages/WalletPage";
import { BusinessPage } from "./pages/BusinessPage";
import { InvestPage } from "./pages/InvestPage";
import { ContactsPage } from "./pages/ContactsPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";

function AppContent() {
  const location = useLocation();
  const hasHero = ["/", "/wallet", "/business", "/invest"].includes(location.pathname);

  const themeMap: Record<string, string> = {
    "/business": "business",
    "/invest": "invest",
  };
  const theme = themeMap[location.pathname];

  return (
    <Layout headerTransparent={hasHero} dataTheme={theme}>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/invest" element={<InvestPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
